// Shared helper for React error boundaries: a stale JS chunk reference
// after a dev-server rebuild (long-open tab across many hot-reloads) throws
// a "Loading chunk failed" style error that a plain page reload fixes
// instantly. Auto-recover once (guarded so it can never reload-loop) instead
// of showing an error screen for that specific, non-bug case.
const RELOAD_GUARD_KEY = "sc_chunk_reload_at";

export function isStaleChunkError(error) {
  const msg = String(error?.message || "");
  return /loading chunk|failed to fetch dynamically imported module|importing a module script failed/i.test(msg);
}

export function autoReloadOnStaleChunk(error) {
  if (!isStaleChunkError(error)) return false;
  const lastReload = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
  if (Date.now() - lastReload > 10000) {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    window.location.reload();
  }
  return true;
}
